var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { StudyVersionStatus } from "healthex-common/study.dtos";
import { computed, observable, reaction } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { HealthSystemBaseViewModel } from "./HealthSystemBaseViewModel";
import { SimpleDialogModel } from "./SimpleDialogModel";
export class SiteStudyDetailsViewModel extends HealthSystemBaseViewModel {
    constructor(container) {
        super(container);
        this.declineConfirmationDialog = new SimpleDialogModel();
        this.teamMembersDialog = new SimpleDialogModel();
        this.study = NOT_LOADED;
        this.studyManager = container.studyManager;
        reaction(() => this.studyId, async () => {
            await this.refreshStudy();
        }, { fireImmediately: true });
    }
    get studyId() {
        var _a, _b;
        return (_b = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.projectId) !== null && _b !== void 0 ? _b : null;
    }
    get showShareRecruitmentButton() {
        return this.authManager.isProvider;
    }
    get studyTitle() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.title;
    }
    get studySponsor() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.sponsorOrganizationName;
    }
    get studyStats() {
        var _a;
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return (_a = this.study.stats) !== null && _a !== void 0 ? _a : null;
    }
    get atAGlanceStatsInfo() {
        if (!this.studyStats)
            return null;
        return [
            {
                total: this.studyStats.totalIdentifiedPatients,
                text: "Patients identified",
                tooltipText: "The number of patients within your organization who have been identified as meeting the initial eligibility criteria for this study.",
            },
            {
                total: this.studyStats.totalPrescreenConsentedPatients +
                    this.studyStats.totalReadyToEnrollingPatients +
                    this.studyStats.totalEnrolledPatients,
                text: "Patients prescreened",
                tooltipText: "The number of patients who have provided consent for prescreening, enabling approved researchers to determine eligibility for this study.",
            },
            {
                total: this.studyStats.totalEnrolledPatients,
                text: "Patients enrolled",
                tooltipText: "The number of patients who have provided consent to be enrolled in this study.",
            },
            {
                total: this.studyStats.totalAnyRecordsAccessedPatients,
                text: "Patient's data accessed",
                tooltipText: "The number of patients whose identified data has been accessed by approved researchers for this study.",
            },
        ];
    }
    async refreshStudy() {
        if (this.studyId === null)
            return;
        this.study = await this.studyManager.getStudy(this.studyId, StudyVersionStatus.ACTIVE);
    }
    onBack() {
        this.routingUIManager.navigateBack();
    }
    isMe(studyUser) {
        return this.authManager.id === studyUser.user.id;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], SiteStudyDetailsViewModel.prototype, "study", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SiteStudyDetailsViewModel.prototype, "studyId", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SiteStudyDetailsViewModel.prototype, "studyTitle", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SiteStudyDetailsViewModel.prototype, "studySponsor", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SiteStudyDetailsViewModel.prototype, "studyStats", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SiteStudyDetailsViewModel.prototype, "atAGlanceStatsInfo", null);
